/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createSwitchController } from '@jira/platform__controllers-switch/src/index.tsx';

const dest = createSwitchController<string | undefined>('jira-switch-modals');
const useSwitch: (active?: string | undefined) => readonly [
	boolean,
	{
		readonly on: () => void;
		readonly off: () => void;
		readonly toggle: () => void;
	},
] = dest.useSwitch;

export const useSwitchModals: (active?: string | undefined) => readonly [
	boolean,
	{
		readonly on: () => void;
		readonly off: () => void;
		readonly toggle: () => void;
	},
] = useSwitch;

export type UseSwitchModalsType = typeof useSwitch;
